// use checkout.globals as the globals hash in jemplate.process
CheckoutV2.Review = function(checkout) {
	var review = this;

	this.init = function() {
		review.className = 'CheckoutV2.Review';
		var orig_totals = JSON.parse( JSON.stringify( checkout.cart.totals.values ));
		review.totals = new CheckoutV2.Cart.Totals( checkout, checkout.cart, true, orig_totals );
		review.totals.taxRate = checkout.cart.totals.taxRate;
		review.totals.taxShipping = checkout.cart.totals.taxShipping;
		review.totals.taxValue = checkout.cart.totals.taxValue;
		review.payment = new CheckoutV2.Payment( checkout, checkout.payment, true, review.totals );
		review.listen();
	};

	this.buildPaymentSummary = function() {
		var content = "";
		
		if (checkout.log.enabled) {
			checkout.log.debug('checkout.payment.getData', checkout.payment.getData(true), review.className);
			checkout.log.debug('review.payment.getData', review.payment.getData(true), review.className);
			checkout.log.debug('checkout.payment.cart_totals.values', checkout.payment.cart_totals.values, review.className);
			checkout.log.debug('review.payment.cart_totals.values', review.payment.cart_totals.values, review.className);
		}
		
		if (review.payment.methodRequired) { // || checkout.session.get('requestReviewPayment')
			content += Object.keys( review.payment.methods ).map(function(e) {
				return Jemplate.process( 'includes/partials/payment/review/method.html', review.payment.methods[e].buildReview() )
			}).join("");
		}
		for (var label in review.payment.cart_totals.values.balances) {
			content += Jemplate.process( 'includes/partials/payment/review/method.html', { method_name: label, payment_amount: review.payment.cart_totals.values.balances[label] } );
		}
		$('.payment-method-creditcard-review-container').html(content);
		$('.payment-methods-review .card-address').popover();
	};
	
	this.listen = function() {
		
	};

	this.init();

};


